/**
 * Shared helpers for the Comparison panels — row-grid template builder
 * and the dash-fallback renderer for empty / null cells. Lives next to
 * ComparisonRowLabel + ComparisonSiteHeader.
 *
 * Linear: MYD-217 (F2).
 */

import type { ReactNode } from 'react'

const LABEL_COL_WIDTH = 200
const SITE_COL_MIN = 180

export const gridTemplate = (siteCount: number) =>
	`${LABEL_COL_WIDTH}px repeat(${siteCount}, minmax(${SITE_COL_MIN}px, 1fr))`

export const renderDash = (value: ReactNode | null | undefined): ReactNode => {
	if (value == null) return <span className="text-gray-400">—</span>
	if (typeof value === 'string' && value.trim().length === 0) {
		return <span className="text-gray-400">—</span>
	}
	return value
}
